module.exports = __webpack_public_path__ + "img/icon-buy-shadow.a7f4760e.png";